import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useUserProfileQuery } from "../../hooks/useUserProfileQuery";
import { setAuditActor } from "../../redux-store/actions/auditActions";
import { IAdminSession } from "../../axios/adminProfile";
import { IUser } from "../../Components/BrandSettings/DashboardUsers/users-hooks";

const isAdminRemote = () =>
  localStorage.getItem("isKoinzAdminRemote") &&
  localStorage.getItem("isRemoteAuthentication");

export const UserProfileInitializer: React.FC = () => {
  const dispatch = useDispatch();
  const { data } = useUserProfileQuery();
  const admin = isAdminRemote();

  useEffect(() => {
    if (!data) return;

    if (admin) {
      const profile = data as IAdminSession;
      dispatch(
        setAuditActor({
          id: profile.id,
          name: profile.user_name,
          email: profile.email,
          actor_type: "admin",
        })
      );
    } else {
      const profile = data as IUser;
      dispatch(
        setAuditActor({
          id: profile.id,
          name: profile.name,
          email: profile.email,
          actor_type: "merchant",
        })
      );
    }
  }, [data, dispatch, admin]);

  return null;
};